import { Button, Divider, Link, Stack, Typography } from "@mui/material";
import WushCard from "../../layout/WushCard";
import { useNavigate } from "react-router-dom";
import ReservationDateRange from "../../text/ReservationDateRange";
import OrderStatusChip from "../orders/OrderStatusChip";

export default function ExpandedReservationCard({reservation}) {
  const customer = reservation?.order?.customer;
  const location = reservation?.order?.location;

  const navigate = useNavigate();

  const reservationAddressString = () => {
    return `${reservation?.order?.location?.address_1} ${reservation?.order?.location?.city} ${reservation?.order?.location?.state} ${reservation?.order?.location?.zip}`;
  };

  const handleGoogleMaps = () => {
    window.open(`https://www.google.com/maps/search/?api=1&query=${reservationAddressString()}`);
  };

  return (
    <Stack>
      <Stack spacing={2}>
        <WushCard>
          <Stack px={2} py={1}>
            <Typography variant="body2" color="grey">
              Customer Information
            </Typography>
            <Typography variant="h5" sx={{ my: "auto" }}>
              {customer.full_name}
            </Typography>
            <Typography variant="h6" sx={{ my: "auto" }}>
              <Link href={`tel:${customer.phone}`}>
                {customer.phone}
              </Link>
            </Typography>
            <Typography variant="h6" sx={{ my: "auto" }}>
              <Link href={`mailto:${customer.email}`}>
                {customer.email}
              </Link>
            </Typography>
          </Stack>
        </WushCard>
        {location && <WushCard>
          <Stack p={2}>
            <Typography variant="body2" color="grey">
              Delivery Information
            </Typography>
            <Typography variant="h6" sx={{ my: "auto" }}>
              {location.name}
            </Typography>
            <Typography variant="body1" sx={{ my: "auto" }}>
              {location.address_1}, {location.city}, {location.state} {location.zip}
            </Typography>
            <Stack direction="row" pt={1}>
              <Button onClick={handleGoogleMaps} variant="outlined">
                View in Google Maps
              </Button>
            </Stack>
          </Stack>
        </WushCard>}
        <WushCard>
          <Stack p={2}>
            <Typography variant="body2" color="grey">
              Reservation Summary
            </Typography>
            <ReservationDateRange variant="body1" fontWeight={400} reservation={reservation} />
            <Stack mt={1}>
              {reservation.reservation_items.map((reservationItem) => (
                <Stack key={reservationItem.id}>
                  <Stack>
                    <Typography variant="body1">{reservationItem.quantity}x {reservationItem.item.name} ({reservation.bookable_duration.name})</Typography>
                  </Stack>
                </Stack>
              ))}
            </Stack>
            <Stack mb={1}>
              {reservation.reservation_answers?.length > 0 && <Stack>
                <Stack my={1}>
                  <Divider />
                </Stack>
                <Stack mb={1}>
                  <Typography variant="body2" color="grey">
                    Reservation Questions
                  </Typography>
                  {reservation.reservation_answers.map((answer) => (
                    <Stack key={answer.id} direction="row" spacing={1}>
                      <Typography variant="body1" fontWeight="700">
                        {answer.reservation_question.question}
                      </Typography>
                      <Typography variant="body1">
                        {[ 'boolean', 'acknowledgement' ].includes(answer.reservation_question.answer_data_type) ? answer.answer === 't' ? "Yes" : "No" : answer.answer}
                      </Typography>
                    </Stack>
                  ))}
                </Stack>
              </Stack>}
            </Stack>
            <Stack>
              <Typography variant="body1" fontStyle="italic">
                <b>Comments:</b> {reservation?.admin_comments || 'N/A'}
              </Typography>
            </Stack>
          </Stack>
        </WushCard>
        <WushCard>
          <Stack p={2} spacing={1}>
            <Typography variant="body2" color="grey">
              Order Information
            </Typography>
            <Stack>
              <OrderStatusChip order={reservation.order} />
            </Stack>
            <Stack>
              <Typography variant="body1" fontStyle="italic">
                <b>Comments:</b> {reservation?.order?.admin_comments || 'N/A'}
              </Typography>
            </Stack>
            <Stack direction="row">
              <Button variant="outlined" onClick={() => navigate(`/orders/${reservation.order_id}`)}>
                View Order
              </Button>
            </Stack>
          </Stack>
        </WushCard>
      </Stack>
    </Stack>
  );
} 
